import {
    Column,
    Container,
    colorWithOpacity,
    cssVar,
    Header,
    Label,
    Row,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React from 'react';
import styled from 'styled-components';

const SliderComponent = styled.input`
    -webkit-appearance: none;
    overflow: visible;
    width: 100%;
    background: transparent;
    outline: none;

    --min: ${({ min }) => `${min}`};
    --max: ${({ max }) => `${max}`};
    --value: ${({ value }) => `${value}`};
    --range: calc(var(--max) - var(--min));
    --ratio: calc((var(--value) - var(--min))/var(--range));
    --sx: calc(.5*1.5em + var(--ratio)*(100% - 1.5em));

    ::-webkit-slider-runnable-track {
        -webkit-appearance: none;
        background: linear-gradient(${({ $error }) => ($error ? cssVar.colorError : cssVar.colorPrimary)}, ${({ $error }) => ($error ? cssVar.colorError : cssVar.colorPrimary)}) 0/var(--sx) 100% no-repeat ${({ $color }) => ($color === 'dual' ? cssVar.colorSecondary : colorWithOpacity(cssVar.colorSecondary, cssVar.opacityLight))};
        height: 10px;
        border-radius: ${cssVar.radiusLarge};
      }

    ::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: ${cssVar.colorPrimary};
        border: 2px solid ${cssVar.colorLightMode};
        margin-top: -5px;
     }

    ::-moz-range-thumb {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: ${cssVar.colorPrimary};
        border: 2px solid ${cssVar.colorLightMode};
        margin-top: -5px;
    }

   ::-moz-range-progress {
        height: 10px;
        border-radius: ${cssVar.radiusLarge};
        background-color: ${({ $error }) => ($error ? cssVar.colorError : cssVar.colorPrimary)};
      }

    ::-moz-range-track {
        height: 10px;
        border-radius: ${cssVar.radiusLarge};
        background-color: ${({ $unit }) => ($unit === '%' ? cssVar.colorSecondary : cssVar.colorStrokeLight)};
      }
`;

const CustomSlider = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    const getSlider = () => {
        const type = props.type;
        let unit = props.unit || '';
        const unitAlignment = props.unitAlignment || 'right';
        const header = props.header || false;
        const min = props.min;
        const max = props.max;
        const labelL = props.leftLabel;
        const labelR = props.rightLabel;
        let increment = props.increment || 1;
        const valSeparator = props.valueSeparator || false;
        const value = props.value || min || 0;

        const labels = props.Labels || false;
        let labelSize = 0;
        if (labels) {
            labelSize = 12 / (labels.length + 2);
        }

        let displayValue = value;
        let minLabelText = min || 0;
        let maxLabelText = max || 100;

        if (type === 'ratio') {
            unit = '%';
        }

        if (increment >= max) {
            increment = 1;
        }

        if (valSeparator) {
            displayValue = displayValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            minLabelText = minLabelText.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            maxLabelText = maxLabelText.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }

        if (unitAlignment === 'right') {
            minLabelText = `${minLabelText} ${unit}`;
            maxLabelText = `${maxLabelText} ${unit}`;
        } else {
            minLabelText = `${unit} ${minLabelText}`;
            maxLabelText = `${unit} ${maxLabelText}`;
        }

        const _isDesktop = props.isDesktop;
        const _isTablet = props.isTablet;
        const isMobile = props.isMobile;

        return (
            <React.Fragment>
                {header && (
                    <Row>
                        <Column xs={6}>
                            {unitAlignment === 'right' ? (
                                <Header
                                    size={sizes.md}
                                    textAlign={alignments.left}
                                    color={cssVar.colorPrimary}
                                    text={`${displayValue || '0'} ${unit}`}
                                />
                            ) : (
                                <Header
                                    size={sizes.md}
                                    textAlign={alignments.left}
                                    color={cssVar.colorPrimary}
                                    text={`${unit} ${displayValue || '0'}`}
                                />
                            )}
                        </Column>
                        {type === 'ratio' && (
                            <Column xs={6}>
                                <Header
                                    size={sizes.md}
                                    textAlign={alignments.right}
                                    color={cssVar.colorSecondary}
                                    text={`${100 - value || '0'} ${unit}`}
                                />
                            </Column>
                        )}
                    </Row>
                )}
                <Row>
                    <Column md={12}>
                        {type === 'ratio' ? (
                            <Container inline>
                                <Column xs={isMobile ? 2 : 1}>
                                    <Container fullSize>
                                        <Label
                                            size={sizes.md}
                                            text={`${labelL}`}
                                            textAlign={alignments.right}
                                            color={cssVar.colorSecondary}
                                        />
                                    </Container>
                                </Column>

                                <SliderComponent
                                    type={'range'}
                                    min={0}
                                    max={100}
                                    step={1}
                                    onInput={(e) => {
                                        props.changeEvent(e.target.value);
                                    }}
                                    value={value || 0}
                                    $error={props.error}
                                    $color={'dual'}
                                    $unit={unit}
                                />

                                <Column xs={isMobile ? 2 : 1}>
                                    <Container fullSize>
                                        <Label
                                            size={sizes.md}
                                            text={`${labelR}`}
                                            textAlign={alignments.left}
                                            color={cssVar.colorSecondary}
                                        />
                                    </Container>
                                </Column>
                            </Container>
                        ) : (
                            <SliderComponent
                                type={'range'}
                                min={min}
                                max={max}
                                step={`${increment}`}
                                onInput={(e) => {
                                    props.changeEvent(e.target.value);
                                }}
                                value={value || min}
                                $error={props.error}
                                $unit={unit}
                            />
                        )}
                    </Column>
                </Row>
                <Row>
                    {type === 'ratio' && labelL && labelR ? (
                        <>
                            <Column xs={labelSize} />
                            {labels?.map((label, idx) => (
                                // biome-ignore lint/suspicious/noArrayIndexKey: labels are positional and stable in order
                                <Column key={idx} xs={labelSize}>
                                    <Container fullSize>
                                        <Label size={sizes.md} text={`${label}`} color={cssVar.colorPrimary} />
                                    </Container>
                                </Column>
                            ))}
                            <Column xs={labelSize}> </Column>
                        </>
                    ) : (
                        <Row>
                            <Column xs={6}>
                                <Container fullSize>
                                    <Label size={sizes.md} text={`${minLabelText}`} textAlign={alignments.left} />
                                </Container>
                            </Column>
                            <Column xs={6}>
                                <Container fullSize>
                                    <Label size={sizes.md} text={`${maxLabelText}`} textAlign={alignments.right} />
                                </Container>
                            </Column>
                        </Row>
                    )}
                </Row>
            </React.Fragment>
        );
    };

    return (
        <Row>
            <Column md={12}>{getSlider()}</Column>
        </Row>
    );
};

export default CustomSlider;
